var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-template',[_c('b-col',{attrs:{"md":"8"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('h2',[_vm._v("Confirmação da Inscrição")]),_vm._v(" "),_c('p',[_vm._v("Prezado (a), recebemos a solicitação da sua inscrição. Até o dia 14 de novembro, você receberá um e-mail para acessar o portal de credenciamento.")])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/auth/SucessoInscricao.vue?vue&type=template&id=a1807494&
// module id = null
// module chunks = 